import { useCallback } from 'react';

import type { Id } from '@e-socna/data-layer';

import { usePrinterContext } from '../../../contexts/PrinterContext/hooks/usePrinterContext.hook';
import type { OnPrintHandler } from '../../../components/DocumentEditor/types/props.type';

import { useQueryInvalidation } from './useQueryInvalidation.hook';

interface Params {
  readonly missionQuotationId: Id;
  readonly snackbarActionTarget: string;
}

export const usePrintHandler = ({
  missionQuotationId,
  snackbarActionTarget,
}: Readonly<Params>) => {
  const { queryKeyToInvalidate } = useQueryInvalidation(missionQuotationId);

  const { print } = usePrinterContext();

  const onPrint = useCallback<OnPrintHandler>(
    (params) => {
      print({
        ...params,
        printableId: missionQuotationId,
        snackbarActionTarget,
        command: 'printMissionQuotation',
        queryKeysToInvalidate: [queryKeyToInvalidate],
      });
    },
    [missionQuotationId, print, queryKeyToInvalidate, snackbarActionTarget],
  );

  return { onPrint };
};
